import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingComponent from "./LoadingComponent";

const ConfirmBookingForm = ({ setConfirmForm, crt }) => {
  // const { cart, totalQuantity, totalPrice, allNames } = useSelector(
  const { cart, totalQuantity, totalPrice } = useSelector(
    (state) => state.allCart
  );

  const services = cart.map((e) => e.fullName);

  // ------------------------------------------------
  const [loading, setLoading] = useState(false);

  // post ----------------------------------------------------------

  const [error, setError] = useState(null);
  const pageFullUrl = window.location.href;

  const navigate = useNavigate();

  const [data, setData] = useState({
    pageUrl: pageFullUrl,
    cartData: cart,
    servicesName: services,
    totalServices: cart.length,
    servicesQuantity: totalQuantity,
    totalPrice: totalPrice,
    name: "",
    phone: "",
    address: "",
    user: "true",
    status: "true",
    serviceDate: "",
    serviceTime: "",
  });

  const handleChange = (e) => {
    const value = e.target.value;

    setData({
      ...data,
      [e.target.name]: value,
    });
  };




  
  
  const handleNumber = (e) => {
    const value = e.target.value;
    setError(null);

    if (value.length <= 10) {
      setData({
        ...data,
        phone: value,
      });
    }

  };
 

  const handleDateChange = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      serviceDate: value,
    serviceTime: "",
    });
  };


  
  // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  
    const today = new Date().toISOString().split('T')[0];
  
    const timeSlots = [
      { value: '8:00am-10:00am', hour: 8 },
      { value: '10:00am-12:00pm', hour: 10 },
      { value: '12:00pm-2:00pm', hour: 12 },
      { value: '2:00pm-4:00pm', hour: 14 },
      { value: '4:00pm-6:00pm', hour: 16 },
      { value: '6:00pm-8:00pm', hour: 18 }
    ];
  
    const getFilteredTimeSlots = () => {
      if (data.serviceDate !== today) return timeSlots;
      const currentHour = new Date().getHours();
      return timeSlots.filter(slot => slot.hour > currentHour);
    };
  
  
  
  
  
  const handleSubmit = async (e) => {
    setLoading(true);

    e.preventDefault();


    if (data.phone.length != 10) {
      setError("enter the valid number");

    } else {

    try {
      // const response = await fetch("http://localhost:8000/booking-form", {
      const response = await fetch("https://api.shop.glazma.com/booking-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        navigate("/thank-you");
        window.location.reload();
      } else {
        const res_data = await response.json();
        alert(res_data.message);
      }
    } catch (error) {
      alert("server error");
    }
    
    }
    

    
    setLoading(false);
  };

  console.log("services = ", services);

  return (
    <div>
      {loading ? (
        <div className="data-loading">
          <LoadingComponent />
        </div>
      ) : (
        ""
      )}

      <div className="confirm-booking">
        <div>
          <div className="confirm-booking-close-btn">
            <i
              className="fa-solid fa-circle-xmark"
              onClick={(e) => setConfirmForm(false)}
            ></i>
          </div>
          <div className="confirm-booking-heading">Confirm Booking</div>

          <div className="confirm-booking-form">
            <form onSubmit={handleSubmit}>


          <div className="confirm-booking-form-row">

              <div>
                <label>Name*</label>
                <input
                  required
                  type="text"
                  placeholder="Enter Your Name"
                  name="name"
                  onChange={handleChange}
                />
              </div>

              <div>
                <label>Number*</label>
                <input
                  required
                  type="number"
                  placeholder="Enter Your Number"
                  name="phone"
                  onChange={handleNumber}
                  value={data.phone}
                />
              </div>


              </div>


              <div className="confirm-booking-form-row">

              <div>
                <label>Service Date*</label>
                <input
                  required
                  type="date"
                  placeholder="*Service Date"
                  min={today}
                  onChange={handleDateChange}
                  value={data.serviceDate}
                  name="serviceDate"
                />
              </div>

              <div>
                <label>Service Timing*</label>
                <select
                  required
                  onChange={handleChange}
                  value={data.serviceTime}
                  name="serviceTime"
                >
                  <option value="" disabled selected>
                    --Select Time--
                  </option>
                  {getFilteredTimeSlots().map((slot) => (
                    <option key={slot.value} value={slot.value}>
                      {slot.value}
                    </option>
                  ))}
                </select>
              </div>
              </div>

              {/* <div>
                <label>Address*</label>
                <input
                  required
                  type="text"
                  placeholder="Enter Your Address"
                  name="address"
                  onChange={handleChange}
                  />

              </div> */}
                
                  <div>
                  <label>City*</label>
                         <select required name="address" value={data.address} onChange={handleChange}>

                <option value="" selected disabled>---Select City---</option>
                <option value="Delhi">Delhi</option>
                <option value="Noida">Noida</option>
                <option value="Greater Noida">Greater Noida</option>
                <option value="Gurugram">Gurugram</option>
                <option value="Ghaziabad">Ghaziabad</option>
                <option value="Faridabad">Faridabad</option>
                
              </select>
     
                
              </div>

{
  error?
  <div className="confirm-booking-form-error">{error}</div>
  :""
}


              <button>Book Now</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBookingForm;
